import { SettingsRoute } from '../enums/settingsRoute'

export const userSettingsRoutes = [
  SettingsRoute.Profile,
  SettingsRoute.ProfileNotifications,
  SettingsRoute.ProfilePrivacy,
  SettingsRoute.ProfileOrganizations,
]
